// Copyright 1999-2020. Plesk International GmbH. All rights reserved.
import React from 'react';

/**
 * `SelectOptionGroup` is a part of [Select](#!/Select) component. It can be used for splitting the list of all options into groups.
 * @since 2.3.0
 */
var SelectOptionGroup = function SelectOptionGroup(_props) {
  // styleguidist doesn't show Props & Methods if component renders nothing
  // eslint-disable-next-line no-constant-condition
  if (false) {
    return React.createElement("optgroup", null);
  }

  return null;
};

export default SelectOptionGroup;